import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/google-icon.png'
import _imports_1 from '../assets/img/facebook-icon.png'


const _hoisted_1 = { class: "login-l" }
const _hoisted_2 = { class: "h1" }
const _hoisted_3 = { class: "hello" }
const _hoisted_4 = { class: "txt" }
const _hoisted_5 = { class: "text-center social" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Google", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  alt: "login with google",
  src: _imports_0
}, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Facebook", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  alt: "login with facebook",
  src: _imports_1
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger font-weight-bold error_msg"
}
const _hoisted_13 = { for: "email" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "text-danger mt-1 font-weight-bold error_msg"
}
const _hoisted_16 = { for: "password" }
const _hoisted_17 = ["type"]
const _hoisted_18 = {
  key: 2,
  class: "text-danger mt-1 font-weight-bold error_msg"
}
const _hoisted_19 = { class: "forget" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "loading"
}
const _hoisted_23 = { class: "creat-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AuthContainer = _resolveComponent("AuthContainer")!

  return (_openBlock(), _createBlock(_component_AuthContainer, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Login')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Welcome to the Matress')), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Fill in the data and then enjoy the best types of mattresses")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.loginWithGoogle && $options.loginWithGoogle(...args))),
            class: "mb-3 mt-2 d-inline-block"
          }, _hoisted_8),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.loginWithFacebook && $options.loginWithFacebook(...args))),
            class: "mb-3 mt-2 d-inline-block"
          }, _hoisted_11)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleLogin && $options.handleLogin(...args)), ["prevent"]))
        }, [
          (_ctx.error_msg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error_msg), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group--error': (_ctx.v$.login.email.$error && _ctx.login.email.length === 0 ) || _ctx.error_msg}])
          }, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('Email Address')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              id: "email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.login.email.$model) = $event)),
              placeholder: _ctx.$t('Email Address')
            }, null, 8, _hoisted_14), [
              [_vModelText, _ctx.v$.login.email.$model]
            ]),
            (_ctx.v$.login.email.$error && _ctx.login.email.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.v$.login.email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group mb-2", { 'form-group--error': (_ctx.v$.login.password.$error && _ctx.login.password.length === 0) || _ctx.error_msg }])
          }, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('Password')), 1),
            _withDirectives(_createElementVNode("input", {
              type: $options.passwordInputType,
              class: "form-control",
              id: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.login.password.$model) = $event)),
              placeholder: "********"
            }, null, 8, _hoisted_17), [
              [_vModelDynamic, _ctx.v$.login.password.$model]
            ]),
            (_ctx.showPassword)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword)),
                  class: "toggle-password fa fa-fw fa-eye"
                }))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword)),
                  class: "toggle-password fa fa-fw fa-eye-slash"
                })),
            (_ctx.v$.login.password.$error && _ctx.login.password.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.v$.login.password.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_router_link, { to: "forget_password" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Forget Password')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary align-self-center",
            disabled: _ctx.loading
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('Login')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('loading')), 1))
          ], 8, _hoisted_20),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_router_link, { to: "signup" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Create New Account')), 1)
              ]),
              _: 1
            })
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}